import Cookies from "js-cookie";

const TokenKey = 'wap-token'

export function getToken() {
	return process.env.VUE_APP_HOOK_SID || Cookies.get(TokenKey)
}

export function saveToken(token) {
	Cookies.set(TokenKey, token)
}
export function removeToken() {
	Cookies.remove(TokenKey)
}